import React, { createContext, useContext, useState } from 'react'

const HeaderConfigContext = createContext()
const HeaderConfigUpdateContext = createContext()

export function useHeaderConfig() {
  return useContext(HeaderConfigContext)
}

export function useHeaderConfigUpdate() {
  return useContext(HeaderConfigUpdateContext)
}

export default function HeaderConfigProvider({ children, setHeader }) {
  const [headerConfig, setHeaderConfig] = useState({})
  const updateHeaderConfig = React.useCallback(
    (newHeader = {}) => {
      setHeader?.(newHeader)
      setHeaderConfig(newHeader)
    },
    [setHeader]
  )

  return (
    <HeaderConfigContext.Provider value={headerConfig}>
      <HeaderConfigUpdateContext.Provider value={updateHeaderConfig}>{children}</HeaderConfigUpdateContext.Provider>
    </HeaderConfigContext.Provider>
  )
}
